// extracted by mini-css-extract-plugin
export default {"label":"ColorInput_label__iIxpj","selectedColor":"ColorInput_selectedColor__6rMDl","options":"ColorInput_options__5oDXT"};